module.exports = __webpack_public_path__ + "static/fusion02-e0028cb040ab06cc48d235b78020343f.png";